import { useCallback, useRef } from 'react';
import { Location, useNavigate } from 'react-router-dom';
import { BUSINESS_ROUTE } from 'data/global';

export type NavigateBackConfig = {
  timeout?: number;
  fallbackRoute?: string;
  excludeRoutes?: string[];
  replace?: boolean;
};

export default function usePreviousLocation() {
  const prevLocRef = useRef<Location>(null);

  const previousLocation = prevLocRef.current;

  const navigate = useNavigate();

  const updatePreviousLocation = useCallback(
    (location: Location) => (prevLocRef.current = location),
    [],
  );

  const navigateBack = useCallback(
    (config?: NavigateBackConfig) => {
      const { timeout, fallbackRoute, excludeRoutes, replace } = {
        timeout: 0,
        excludeRoutes: [] as string[],
        replace: false,
        ...(config || {}),
        fallbackRoute: config?.fallbackRoute || BUSINESS_ROUTE,
      };

      const isInvalidRoute =
        !!excludeRoutes.length &&
        previousLocation?.pathname &&
        excludeRoutes.some((route) =>
          previousLocation?.pathname.includes(route),
        );

      setTimeout(
        () =>
          navigate(
            isInvalidRoute ? fallbackRoute : previousLocation || fallbackRoute,
            { replace },
          ),
        timeout,
      );
    },
    [navigate, previousLocation],
  );

  return { previousLocation, updatePreviousLocation, navigateBack };
}
